module.exports = __webpack_public_path__ + "static/media/YMLATJSONBSOTK1.65345977.png";